import { render, staticRenderFns } from "./DailyBonus.vue?vue&type=template&id=627b2b65&scoped=true"
import script from "./DailyBonus.vue?vue&type=script&lang=js"
export * from "./DailyBonus.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=627b2b65&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627b2b65",
  null
  
)

export default component.exports